<mat-dialog-content>
  <div class="flex flex-col gap-6 p-4">
    <div class="flex flex-col items-center text-center">
      <div class="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mb-3">
        <i class="fi-rr-download text-2xl text-orange-500"></i>
      </div>
      <h2 class="font-semibold text-xl text-gray-800 mb-2">
        Descargar plantilla de {{ data.entityLabel }}
      </h2>
      <p class="text-gray-500 text-sm">
        Selecciona qué registros deseas incluir en el archivo Excel.
      </p>
    </div>

    <div class="flex flex-col gap-3">
      <button
        type="button"
        class="w-full text-left p-4 rounded-2xl border-2 border-gray-200 hover:border-orange-300 hover:bg-orange-50 transition-all cursor-pointer"
        (click)="select('FILTERED')">
        <span class="flex items-center gap-3">
          <i class="fi-rr-filter text-xl text-orange-500"></i>
          <span class="flex flex-col">
            <span class="font-semibold text-gray-800">Registros filtrados</span>
            <span class="text-sm text-gray-500">
              {{ data.filteredCount }} registro(s) que coinciden con los filtros actuales.
            </span>
            <span class="text-xs text-gray-500 mt-1">
              Sin filtros, se descargará la página actual.
            </span>
          </span>
        </span>
      </button>

      <button
        type="button"
        class="w-full text-left p-4 rounded-2xl border-2 border-gray-200 hover:border-orange-300 hover:bg-orange-50 transition-all cursor-pointer"
        (click)="select('ALL')">
        <span class="flex items-center gap-3">
          <i class="fi-rr-database text-xl text-orange-500"></i>
          <span class="flex flex-col">
            <span class="font-semibold text-gray-800">Todos los registros</span>
            <span class="text-sm text-gray-500">
              Descarga todos los {{ data.entityLabel }} disponibles.
            </span>
          </span>
        </span>
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end px-6 pb-5">
  <button
    type="button"
    class="rounded-3xl bg-gray-200 text-gray-700 py-2 px-6 cursor-pointer hover:bg-gray-300 transition-all"
    (click)="cancel()">
    Cancelar
  </button>
</mat-dialog-actions>
